<template>
	<v-navigation-drawer
		:value="drawer"
		:clipped="$vuetify.breakpoint.lgAndUp"
		app
		:color="`${isDark ? '#121212' : 'white'}`"
	>
		<v-list dense>
			<template v-for="(item, index) in items.filter(item => {
				// Check user role first
				if (userRole < item.minRole) {
					return false;
				}

				// Check additional permissions if the role is not sufficient
				if (item.additionalPermissions.length > 0) {
					const permissions = item.additionalPermissions
						.map(permission => currentUser[permission])
						.filter(permission => permission === true);

					if (permissions.length > 0) {
						return true;
					}
				}

				return true;
			})">
				<v-tooltip
					v-if="item.locked"
					:key="`locked-${index}`"
					top
				>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<v-list-item
								:to="`/${lang}/${item.route}`"
								:disabled="true"
							>
								<v-list-item-content>
									<v-list-item-title>
										{{ $t(`sidenav-menu.${item.name}`) }}
										<v-icon
											small
											class="ml-1"
											color="grey"
										>
											lock
										</v-icon>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
					</template>
					{{ $t('tooltip.feature-not-available-in-package') }}
				</v-tooltip>
				<v-list-item
					v-else
					:key="`unlocked-${index}`"
					:to="`/${lang}/${item.route}`"
				>
					<v-list-item-content>
						<v-list-item-title>
							{{ $t(`sidenav-menu.${item.name}`) }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';

export default {
	props: {
		isOpened: {
			type: Boolean,
			required: false,
			default() {
				return false;
			},
		},
	},
	computed: {
		...mapState({
			lang: state => state.currentUser.lang,
			drawer: state => state.currentRoute.drawer,
			isDark: state => state.currentUser.isDark,
			currentUser: state => state.currentUser.currentUser,
			userRole: state => state.currentUser.userRole,
			company: state => state.company.company,
		}),
		items() {
			return [
				{
					name: 'my-account',
					route: 'settings/my-account',
					minRole: 333,
					additionalPermissions: [],
				},
				{
					name: 'users',
					route: 'settings/users',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'company',
					route: 'settings/company',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'e-mail-layouts',
					route: 'settings/email-layouts',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'e-mail-templates',
					route: 'settings/email-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'instant-booking',
					route: 'settings/instant-booking',
					minRole: 666,
					additionalPermissions: [],
					locked: this.company?.package_type?.features?.is_instant_booking_enabled === false,
				},
				{
					name: 'feedback-templates',
					route: 'settings/feedback-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'scorecard-templates',
					route: 'settings/scorecard-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'requisition-form-templates',
					route: 'settings/requisition-form-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'requisition-approval-flow-templates',
					route: 'settings/requisition-approval-flow-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'form-templates',
					route: 'settings/form-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'approval-templates',
					route: 'settings/approval-templates',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'rulesets',
					route: 'settings/rulesets',
					minRole: 777,
					additionalPermissions: [],
				},
				{
					name: 'tags',
					route: 'settings/tags',
					minRole: 666,
					additionalPermissions: [],
				},
				{
					name: 'job-site',
					route: 'settings/job-site',
					minRole: 333,
					additionalPermissions: ['can_edit_career_pages'],
					locked: this.company?.package_type?.features?.is_career_site_enabled === false,
				},
				{
					name: 'resource-usage',
					route: 'settings/resource-usage',
					minRole: 777,
					additionalPermissions: [],
				},
			];
		}
	},
	data() {
		return {};
	}
};
</script>
